import React, { Component } from 'react';
import {
  Image,
} from '..';
import './AboutMobilePortrait.scss';

class AboutMobilePortrait extends Component {
  render() {
    const {
      personalPortrait,
      portraitTimestamp,
      portraitCaption,
    } = this.props;
    return (
      <div className="portrait-photo--mobile">
        <div className="image-container">
          <Image image={personalPortrait} className="cover" />
          <div className="subtitle subtitle-right">
            <div className="subtitle-container has-dot">
              <span>About Me</span>
            </div>
          </div>
          <div className="subtitle subtitle-left">
            <div className="subtitle-container">
              <span>{portraitCaption.text}</span>
            </div>
            <div className="subtitle-container">
              <span>{portraitTimestamp}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutMobilePortrait;
